import CircularProgress from '@mui/material/CircularProgress';
import React, { useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { DefaultTheme } from 'styled-components';
import { ButtonRipple, Container } from './styles';

export type IColor = keyof DefaultTheme['colors'];

export type IRipple = {
  id: string;
  x: number;
  y: number;
};

export interface IPropsStyles {
  background?: IColor;
  color?: IColor;
  textHoverColor?: IColor;
  styleLeftComponent?: React.CSSProperties;
  styleRightComponent?: React.CSSProperties;
  backgroundHoverColor?: IColor;
  border?: Partial<{
    width: number;
    color: IColor;
  }>;
  font?: Partial<{
    size: string | number;
    weight: number;
    uppercase: boolean;
  }>;
  LeftComponent?: React.FC<any>;
  RightComponent?: React.FC<any>;
  positionLeftElement?: number;
  positionRightElement?: number;
}
interface Props extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'color'>, IPropsStyles {
  text: string;
  dimensions?: {
    width: string | number;
    height: string | number;
  };
  loading?: boolean;
}

const ANIMATION_MS = 800;
const CIRCLE_SIZE = 50;

export function Button({
  dimensions,
  text,
  background,
  styleLeftComponent,
  styleRightComponent,
  border: borderProp,
  color,
  type = 'button',
  LeftComponent,
  RightComponent,
  textHoverColor,
  loading = false,
  style,
  onClick,
  backgroundHoverColor,
  ...props
}: Props) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const [ripples, setRipples] = useState<IRipple[]>([]);
  const border = {
    ...borderProp,
    color: borderProp?.color || color,
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (loading) return;
    const box = buttonRef.current?.getBoundingClientRect()!;

    setRipples((state) => [
      ...state,
      {
        id: uuid(),
        x: event.clientX - box.left - CIRCLE_SIZE / 2,
        y: event.clientY - box.top - CIRCLE_SIZE / 2,
      },
    ]);

    setTimeout(() => {
      setRipples(shift);
    }, ANIMATION_MS);

    onClick?.(event);
  };

  function shift(array: any[]) {
    const newArray = [...array];
    newArray.shift();
    return newArray;
  }

  return (
    <Container
      ref={buttonRef}
      onClick={handleClick}
      background={background}
      border={border}
      style={{ width: dimensions?.width, height: dimensions?.height, ...style }}
      type={type}
      color={color}
      textHoverColor={textHoverColor}
      backgroundHoverColor={backgroundHoverColor}
      {...props}>
      {loading ? (
        <CircularProgress size={15} sx={{ ml: 1, color: { color } }} />
      ) : (
        <div className="containerItens">
          {LeftComponent && (
            <div className="containerIcon">
              <LeftComponent className="left-element" style={{ ...styleLeftComponent }} />
            </div>
          )}
          <span className="text">{text}</span>
          {RightComponent && (
            <div className="containerIcon">
              <RightComponent className="right-element" style={{ ...styleRightComponent }} />
            </div>
          )}
        </div>
      )}
      {ripples.map((item) => (
        <ButtonRipple key={item.id} x={item.x} y={item.y} />
      ))}
    </Container>
  );
}
